import React, { useEffect } from 'react';
import { useAlertStore } from 'src/hooks/Alert';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import System from 'src/helper/system';
import Constants from 'src/support/Constants';
import StockAlertListingTable from './StockAlertListingTable';
import Helper from 'src/support/Helper';

const StockAlertTabContent = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ StockAlertListingByType }, fetch] = useAlertStore();
    const [{ filter_list }, { }, { clear_all_filter }] = useFilterSelectionStore();

    useEffect(() => {
        const getList = async () => {
            await clear_all_filter();
        };
        getList();
    }, []);

    const exportData = async () => {
        let params = { "manufacturerPartNumber": "", "customerPartNumber": "", "manufacturerName": "" }
        if (filter_list.length > 0) {
            params[filter_list[filter_list.length - 1].key] = filter_list[filter_list.length - 1].searchKeyword
        }
        const response = await fetch.export_stock_alert_data(params)
        if (response) {
            Helper.downloadFileFromRes(new Blob([response]), 'STOCK_ALERT.xlsx')
            showDownloadMessage();
        }
    };

    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success')
    }


    return (
        <>
            <div id="tab1" className="tab-pane show active table-container">

                <div className="total-section dashboard-hide">
                    Total Stock Alerts:&nbsp;
                    {__check(['STOCK_ALERT_API_CALL'], { inline: true }).render}
                    {!__check(['STOCK_ALERT_API_CALL']).status &&
                        <span>{StockAlertListingByType && StockAlertListingByType.totalCount}</span>
                    }
                </div>

                <div className="d-flex justify-content-between flex-wrap align-items-center dashboard-hide">
                    <div className="sub-section mb-0">
                    </div>
                    <ul className="quick-links ps-0 pb-2 mb-0">

                        <li>
                            {!__check(['EXPORT_ALERT_API_CALL']).status &&
                                <div className="text-blue" style={{
                                    cursor: 'pointer'
                                }} onClick={exportData}><i className="file-export-icon me-2 text-black" />Export
                                </div>}
                            {__check(['EXPORT_ALERT_API_CALL'], { inline: true }).render}
                        </li>
                    </ul>
                </div>

                <StockAlertListingTable />

            </div>
            <div id="tab2" className="tab-pane fade table-container">No Data Found</div>
        </>
    );
}

export default StockAlertTabContent;